import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  interval: {
    from: '',
    to: '',
  },
  data: {},
  meta: {
    loading: false,
    error: false,
    valid: true,
  },
};

const reducerMap = Object.create(null);

reducerMap[types.COMPARISON_UNAVAILABLE] = () => update(initialState, {
  meta: { valid: { $set: false } },
});


reducerMap[types.SET_COMPARISON_INTERVAL] = (state, action) => update(state, {
  interval: {
    $merge: {
      from: action.from,
      to: action.to,
    },
  },
  meta: {
    $merge: {
      valid: true,
    },
  },
});

export default (state = initialState, action) => (
  reducerMap[action.type]
    ? reducerMap[action.type](state, action)
    : state
);
